// Color Code Parser
// Converts color codes (^1, ^2, etc.) to HTML with appropriate colors

const colorCodes = {
  '^0': '#000000', // Black
  '^1': '#FF0000', // Red
  '^2': '#00FF00', // Green
  '^3': '#FFFF00', // Yellow
  '^4': '#0000FF', // Blue
  '^5': '#00FFFF', // Cyan
  '^6': '#FF00FF', // Magenta
  '^7': '#FFFFFF', // White
  '^8': '#666666', // Dark Gray
  '^9': '#999999'  // Light Gray
};

export const parseColors = (text) => {
  if (!text) return '';
  
  // Split text by color codes while preserving the codes
  const parts = text.split(/(\^[0-9])/);
  let currentColor = '#FFFFFF'; // Default white
  let result = [];
  
  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];
    
    if (part.match(/^\^[0-9]$/)) {
      // This is a color code
      currentColor = colorCodes[part] || '#FFFFFF';
    } else if (part.length > 0) {
      // This is text content
      result.push({
        text: part,
        color: currentColor
      });
    }
  }
  
  return result;
};

export const renderColoredText = (coloredParts) => {
  return coloredParts.map((part, index) => (
    <span key={index} style={{ color: part.color }}>
      {part.text}
    </span>
  ));
};